import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { NotificationCard } from '@/components/notifications/NotificationCard';
import { Card } from '@/components/sections/Card';
import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { PageLoading } from '@/layouts/PageLoading';
import { Container } from '@/layouts/main/Main';
import { useMarkNotifcitionAsRead, useMyNotifications } from '@/services/notifications/useNotifications';
import { PageTitle } from '@/utils/Title';
import { FunctionComponent, Suspense, useState } from 'react';
import ReactPaginate from 'react-paginate';

const ITEMS_PER_PAGE = 10;

const NotificationContent: FunctionComponent = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Notifications',
      to: ''
    }
  ];

  const notifications = useMyNotifications();
  const markAsRead = useMarkNotifcitionAsRead();

  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + ITEMS_PER_PAGE;
  const currentItems = notifications.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(notifications.length / ITEMS_PER_PAGE);
  const onPageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * ITEMS_PER_PAGE) % notifications.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
        <div className="flex justify-between gap-5 items-center font-bold">
          <h3 className="text-3xl">Notifications</h3>
        </div>
      </BreadcrumbPageHeader>
      <div className="flex-1 overflow-y-auto">
        <Container animate="pop" className="w-full py-8">
          <div className="flex flex-col space-y-3">
            {notifications.length === 0 && <div className="p-5 text-center text-xl">You have no notifications.</div>}
            {currentItems.map((notification, index) => (
              <Card key={`notification-${index}`}>
                <NotificationCard notification={notification} onClick={() => markAsRead(notification.id)} />
              </Card>
            ))}

            {pageCount > 1 && (
              <ReactPaginate
                nextLabel=">"
                onPageChange={onPageClick}
                pageRangeDisplayed={0}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
                marginPagesDisplayed={0}
                pageLabelBuilder={page => `Page ${page} of ${pageCount}`}
                breakLabel={''}
                containerClassName="flex justify-center items-center space-x-2"
                disabledLinkClassName="opacity-50"
              />
            )}
          </div>
        </Container>
      </div>
    </>
  );
};

const NotificationsPage: FunctionComponent = () => {
  return (
    <>
      <PageTitle>Notifications</PageTitle>
      <Suspense fallback={<PageLoading />}>
        <NotificationContent />
      </Suspense>
    </>
  );
};

export default NotificationsPage;
